export const routesDunyaKupa2026 = [
  {
    path: "/dunyakupa2026",
    name: "dunyakupa2026",
    component: () => import("@/views/dunyakupa2026/index.vue"),
    meta: {
      public: false,
      title: "Dünya Kupası 2026",
      yetki: { k: [1350002] },
    },
  },
  {
    path: "/dunyakupa2026/liderlik",
    name: "dunyakupa2026-liderlik",
    component: () => import("@/views/dunyakupa2026/liderlik.vue"),
    meta: {
      public: false,
      title: "Dünya Kupası 2026 - Liderlik",
      yetki: { k: [1350002] },
    },
  },
]
